/* eslint-disable */
import { useReactToPrint } from 'react-to-print';
import React, { useEffect, useRef, useState } from 'react';
import FirmReport from './FirmReport/FirmReport';
import PracticeReport from './PracticeReport/PracticeReport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import Modal from 'react-modal';

const ExportPracticeFirmPDF = (props) => {
    const reportRefs = useRef();
    const [PDFPrintModalOpen, setPDFPrintModalOpen] = useState(false);
    const [displayPages, setDisplayPages] = useState(props.reportsOnTabs || [])
    const navbar = window.navbar.navbar;
    let pdfButtonId = 'moneyPdfId';

    useEffect(() => {
        setDisplayPages(() => {
            let mainReports = props.reportsOnTabs;
            if (props.page === 'firm') {
                mainReports = mainReports.filter(t => !['naics-analysis', 'dashboard'].includes(t.report))
                mainReports = mainReports.map((tab) => {
                    if (tab?.sub_tabs) {
                        return {
                            ...tab,
                            sub_tabs: tab.sub_tabs.filter(s => 
                                !['client-analysis', 'pnl', 'balance-sheet', 'naics-dashboard'].includes(s.report)
                            )
                        };
                    }
                    return tab
                });
            }
            return [{ id: 0, key: 'cover_page', report: 'cover_page', name: 'Cover Page', checked: true, tab_order: 0 }, ...mainReports]
        })
    }, [props.reportsOnTabs, props.page])

    const pdfIcon = <FontAwesomeIcon icon={faFilePdf} />

    const closePDFPrintModal = () => {
        setPDFPrintModalOpen(false);
    }

    const handlePDFandPrintChecked = (index, isChecked) => {
        setDisplayPages((prevState) => {
            let newOptions = _.cloneDeep(prevState)
            const selectedTab = newOptions[index]

            if (!selectedTab) return newOptions

            selectedTab.checked = isChecked

            if (selectedTab.sub_tabs?.length) {
                selectedTab.sub_tabs = selectedTab.sub_tabs.map((subTab) => ({
                    ...subTab,
                    checked: isChecked,
                }))
            }

            return newOptions
        })
    }

    const handleSubTabChecked = (parentIndex, subTabIndex, isChecked) => {
        setDisplayPages((prevState) => {
            let newOptions = _.cloneDeep(prevState)
            const selectedTab = newOptions[parentIndex]

            if (!selectedTab?.sub_tabs?.[subTabIndex]) return newOptions

            selectedTab.sub_tabs[subTabIndex].checked = isChecked
            selectedTab.checked = selectedTab.sub_tabs.some((subTab) => subTab.checked)

            return newOptions
        })
    }

    const handleOpeningReportBuilder = () => {
        if (props.page === 'firm') {
            props.reportsOnTabs.forEach(tab => {
                if (tab.report === 'generated_naics_main_tab') {
                    const cacheKey = tab?.details?.naics_string;
                    const hasCachedPracticeData = Boolean(props?.practiceData?.[cacheKey]);
                    if (!hasCachedPracticeData) {
                        props.practiceApiCall(tab.details);
                    }
                }
            });
        }
        setPDFPrintModalOpen(true)
    }

    const getPDFButton = () => {
        return (
            <span className='hide-on-print'>
                <button id={pdfButtonId} className='print-pdf-btn' onClick={() => handleOpeningReportBuilder()} aria-hidden='true' >{pdfIcon}</button>
            </span>
        )
    }

    // The PDF print uses a completely separate PDFable Practice and Firm Reports to look at
    const renderReport = () => {
        if (props.page === 'practice') {
            return (
                <PracticeReport
                    {...props}
                    ref={reportRefs}
                    key={'money-report-container-pdf'}
                    displayPages={displayPages}
                    page={'practice'}
                    pdf={true}
                />
            )
        }

        if (props.page === 'firm') {
            return (
                <FirmReport
                    {...props}
                    ref={reportRefs}
                    key={'money-report-container-pdf'}
                    displayPages={displayPages}
                    page={'firm'}
                    pdf={true}
                />
            )
        }
    };

    const handlePrint = useReactToPrint({
        contentRef: reportRefs,
        documentTitle: `${props.name} Report.pdf`,
    });

    // If Plan has access to Practice and Firm Reports then access to PDF and Print is true
    const printPDFExport = () => {
        return (
            <Modal
                className={{
                    base: 'pdf-print-modal-content hide-on-print',
                    afterOpen: 'pdf-print-modal-content_after-open hide-on-print',
                    beforeClose: 'pdf-print-modal-content_before-close hide-on-print',
                }}
                overlayClassName={{
                    base: 'overlay-base hide-on-print',
                    afterOpen: 'overlay-base_after-open hide-on-print',
                    beforeClose: 'overlay-base_before-close hide-on-print',
                }}
                isOpen={PDFPrintModalOpen}
                onRequestClose={closePDFPrintModal}
                shouldCloseOnOverlayClick={true}
                closeTimeoutMS={0}
                contentLabel='PDF and Print Preview'
                ariaHideApp={false}
            >
                <div className='report-builder-container'>
                    <h2>Report Builder</h2>
                    <p>Select Tabs to Include: </p>
                    <div className='report-builder-all-checkboxes'>
                        <div>
                            <div key={`cover_page-checkbox`} className='page-checkbox-input'>
                                <input id={`cover_page-checked`} type='checkbox' name={'cover_page'} value={'cover_page'} checked={displayPages?.[0]?.checked ?? false} onChange={(e) => handlePDFandPrintChecked(0, e.target.checked)} />
                                <label htmlFor={`cover_page-checked`}>Cover Page</label>
                            </div>
                        </div>
                        <div className='report-pages-checkboxes'>
                            {displayPages.slice(1).map((tab, index) => (
                                <div key={`${tab.key}-checkbox`} className='page-checkbox-input-vertical'>
                                    <div className='page-checkbox-input'>
                                        <input id={`${tab.key}-checked`} type='checkbox' name={tab.key} value={tab.key} checked={displayPages?.[index + 1]?.checked ?? false} onChange={(e) => handlePDFandPrintChecked(index + 1, e.target.checked)} />
                                        <label htmlFor={`${tab.key}-checked`}>{tab.name}</label>
                                    </div>
                                    {tab?.sub_tabs?.length > 0 && (
                                        <div className='report-subtabs-checkboxes'>
                                            {tab.sub_tabs.map((subTab, subIndex) => (
                                                <div key={`${subTab.key}-checkbox`} className='page-checkbox-input'>
                                                    <input id={`${subTab.key}-checked`} type='checkbox' name={subTab.key} value={subTab.key} checked={displayPages?.[index + 1]?.sub_tabs?.[subIndex]?.checked ?? false} onChange={(e) => handleSubTabChecked(index + 1, subIndex, e.target.checked)} />
                                                    <label htmlFor={`${subTab.key}-checked`}>{subTab.name}</label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <button id={pdfButtonId} className='run-report-btn pdf-print-action-btn' onClick={handlePrint} aria-hidden='true'>Print my Report</button>
                </div>
                {renderReport()}
            </Modal>
        )
    }

    return (
        <>
            {getPDFButton()}
            {printPDFExport()}
        </>
    )
};
export default ExportPracticeFirmPDF;